import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";

//components
import App from "./app";
import theme from "src/theme/theme";
import "src/styles/index.css";

//redux
import { Provider } from "react-redux";
import store from "src/redux/store";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ChakraProvider theme={theme} resetCss={false}>
      <App />
    </ChakraProvider>
  </Provider>
);
